import React from 'react';
import { string, func } from 'prop-types';
import classnames from 'classnames/bind';

import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import FormField from 'elements/Inputs/FormField';
import InputField from 'elements/Inputs/InputField';

import styles from './SupportBannerGroup.css';

const cx = classnames.bind(styles);

const SupportBannerGroup = ({ title, description, link, placeholder, onClick }) => {
  try {
    if (link && placeholder || !link && !placeholder) {
      throw Error ('SupportBannerGroup is composed by either a link or a input placeholder.');
    }
  }

  catch (err) {
    console.warn(err);
    return null;
  }

  return (
    <div className={styles.group}>
      <p className={styles.groupTitle}>{title}</p>
      <p className={cx('groupDescription', { inputDescription: placeholder })}>
        {description}
      </p>

      {
        link &&
          <LinkFreeStanding
            icon={{ direction: 'right', name: 'arrow-right', type: '20' }}
            size="m"
            withBouncing
            medium
            onClick={onClick}
          >
            {link}
          </LinkFreeStanding>
      }

      { 
        placeholder &&
          <FormField className={styles.input}>
            <InputField
              actionIcon={{icon: 'link-arrow-right-17', type: 'other'}}
              placeholder={placeholder}
              size={'extra-small'}
            handleIconClick={onClick}
            />
          </FormField>
      }
    </div>
  );
};

SupportBannerGroup.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  link: string,
  placeholder: string,
  onClick: func.isRequired
};

SupportBannerGroup.displayName = 'SupportBannerGroup';

export default SupportBannerGroup;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/SupportBanner/SupportBannerGroup/SupportBannerGroup.js